// Utilitaires pour gérer le HTML

/**
 * Nettoie le HTML en supprimant les balises et en gardant seulement le texte
 * @param {string} html - Le HTML à nettoyer
 * @returns {string} - Le texte nettoyé
 */
export const stripHtmlTags = (html) => {
  if (!html) return ''
  
  // Créer un élément temporaire pour parser le HTML
  const temp = document.createElement('div')
  temp.innerHTML = html
  
  // Récupérer le texte sans les balises
  return temp.textContent || temp.innerText || ''
}

/**
 * Tronque le texte à une longueur donnée
 * @param {string} text - Le texte à tronquer
 * @param {number} maxLength - La longueur maximale
 * @returns {string} - Le texte tronqué avec "..." si nécessaire
 */
export const truncateText = (text, maxLength = 100) => {
  if (!text) return ''
  
  const cleanText = stripHtmlTags(text)
  
  if (cleanText.length <= maxLength) {
    return cleanText
  }
  
  return cleanText.substring(0, maxLength).trim() + '...'
}
